import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQueryWithAuth } from "../shared/baseQuery"; 

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getRankedPlayers: builder.query({
      query: ({ category, limit }) => `/players/ranks?category=${category}&limit=${limit}`,
      transformResponse: (response) => {
        response.isSelected = false;
        response.isActive = false;
        for (let i = 0; i < response.length; i++) {
          response[i].isSelected = false;
          response[i].isActive = false;
        }
        return response;
      }
    })
  })
})


export const { 
  useGetRankedPlayersQuery
} = apiSlice